import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "prev", "next"];

  connect() {
    this.modalTarget.addEventListener(
      "close",
      this.enableBodyScroll.bind(this)
    );

    this._turboFrameLoadHandler = this.handleTurboFrameLoad.bind(this);
    this._handleKeyUp = this.handleKeyUp.bind(this);

    document.addEventListener("keyup", this._handleKeyUp);

    this.modalTarget.addEventListener(
      "turbo:frame-load",
      this._turboFrameLoadHandler
    );
  }

  disconnect() {
    this.modalTarget.removeEventListener(
      "close",
      this.enableBodyScroll.bind(this)
    );
    document.removeEventListener("keyup", this._handleKeyUp);
    this.modalTarget.removeEventListener("mousedown", this._mousedownHandler);
    this.modalTarget.removeEventListener("mouseup", this._mouseupHandler);
    this.modalTarget.removeEventListener(
      "turbo:frame-load",
      this._turboFrameLoadHandler
    );
  }

  handleTurboFrameLoad(event) {
    this.modalTarget.showModal();

    if (this.scrollY === undefined) {
      this.disableBodyScroll();
    }
  }

  close() {
    this.modalTarget.close();
  }

  disableBodyScroll() {
    // Save the current scroll position
    this.scrollY = window.scrollY;

    // Use overflow: hidden instead of position: fixed
    // position: fixed breaks touch text selection on iOS/Android
    document.body.style.overflow = "hidden";
  }

  enableBodyScroll() {
    document.body.style.removeProperty("overflow");

    // Restore the scroll position
    if (this.scrollY !== undefined) {
      window.scrollTo(0, this.scrollY);
      this.scrollY = undefined;
    }

    this.pauseMedia();
  }

  pauseMedia() {
    const iframes = this.modalTarget.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      iframe.src = "";
    });
  }

  clickOutside(event) {
    if (event.target === this.modalTarget && this.closedByValue !== "none") {
      this.close();
    }
  }

  handleKeyUp(event) {
    if (event.key === "ArrowLeft") {
      this.prev();
    } else if (event.key === "ArrowRight") {
      this.next();
    }
  }

  prev() {
    this.prevTarget.click();
  }

  next() {
    this.nextTarget.click();
  }
}
